// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2Q26B","search-container":"Navbar_search-container__2FNBS"};